import { motion } from "motion/react";

const items = [
  "3D Animation",
  "3D Anamorphic",
  "3D Mapping",
  "3D Motion Graphics",
  "Augmented Reality solutions",
  "Virtual Reality Solutions",
  "AI Powered System",
  "Software Solutions",
  "Hardware Solutions",
  "LED Screens",
  "Holographic Tubes",
  "Touch Screen Standees",
  "Touch Screen Kiosks",
  "Cameras",
  "AI powered Solutions",
];

export default function Marquee() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="py-6 border-y border-black/10 dark:border-white/10 overflow-hidden flex bg-white/50 dark:bg-[#050505]/50 backdrop-blur-sm relative z-10 transition-colors duration-500"
    >
      <motion.div
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 50, ease: "linear", repeat: Infinity }}
        className="flex whitespace-nowrap gap-12 pr-12"
      >
        {[...items, ...items, ...items].map((item, i) => (
          <div
            key={`${item}-${i}`}
            className="flex items-center gap-6 font-Montserrat text-xs font-semibold uppercase tracking-widest text-black/60 dark:text-white/60"
          >
            <div className="w-1.5 h-1.5 rounded-full bg-black/20 dark:bg-white/20" />
            {item}
          </div>
        ))}
      </motion.div>
    </motion.div>
  );
}